//export const mainurl = "http://localhost/vbox/vbox/index.php/"; 
export const mainurl = "https://api2.boxfarming.in/wsapi/v3/index.php/"; 
export const imgurl = "https://api2.boxfarming.in/wsapi/v3/assets/gf566s7hbff/"; 